import { render, staticRenderFns } from "./SocialCard.vue?vue&type=template&id=1d056667&scoped=true&"
import script from "./SocialCard.vue?vue&type=script&lang=js&"
export * from "./SocialCard.vue?vue&type=script&lang=js&"
import style0 from "./SocialCard.vue?vue&type=style&index=0&id=1d056667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d056667",
  null
  
)

export default component.exports